import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const baseStyles = {
    hr: {
        border: (theme: CarrotTheme) => `1px solid ${theme.colors.lightGrey}`,
        margin: '32px 0',
    },
};

const hr: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
};
export default hr;
